export default "__VITE_ASSET__BVKdGV1b__"